// extracted by mini-css-extract-plugin
export default {"cls1":"VsO3b5_9fiuhjkrm8z3J","cls2":"H58SItGxpBBI4bfapgwc VsO3b5_9fiuhjkrm8z3J","isPhone":"__7P8JZdUyAaaYSF4yrO"};